import { useState } from 'react';
import { HydrationBoundary, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useDehydratedState } from "use-dehydrated-state";

export default function QueryProvider(props: { children: React.ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // With SSR, we usually want to set some default staleTime
            // above 0 to avoid refetching immediately on the client
            staleTime: 60 * 1000,
          },
          // dehydrate: {
          //   serializeData: SuperJSON.serialize,
          //   shouldDehydrateQuery: (query) => 
          //     defaultShouldDehydrateQuery(query) ||
          //     query.state.status === "pending"
          // },
          // hydrate: {
          //   deserializeData: SuperJSON.deserialize,
          // },
        },
      }),
  )
  const dehydratedState = useDehydratedState();

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>
        {props.children}
      </HydrationBoundary>
    </QueryClientProvider>
  )
}